var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.data),function(value,key){return _c('v-col',{key:key,staticClass:"streamfield-btn",attrs:{"cols":"12","sm":"4","md":"4","lg":"4","xl":"4"}},_vm._l((value),function(block,i){return _c('StreamfieldBlock',{key:i,attrs:{"block":block}})}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }